const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * "5 minutes ago" / "yesterday" / "3 weeks ago" in the UI locale, or '' when the
 * user was never seen. Activity is stamped at most every 5 minutes, so anything
 * newer than that reads as the current minute.
 */
export function lastActiveLabel(
  iso: string | null | undefined,
  locale: string,
  now = Date.now(),
): string {
  const time = iso ? new Date(iso).getTime() : NaN;
  if (Number.isNaN(time)) return '';

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  const elapsed = Math.max(0, now - time);
  if (elapsed < HOUR) return rtf.format(-Math.floor(elapsed / MINUTE), 'minute');
  if (elapsed < DAY) return rtf.format(-Math.floor(elapsed / HOUR), 'hour');
  if (elapsed < 7 * DAY) return rtf.format(-Math.floor(elapsed / DAY), 'day');
  if (elapsed < 30 * DAY)
    return rtf.format(-Math.floor(elapsed / (7 * DAY)), 'week');
  return new Date(time).toLocaleDateString(locale);
}
